import { render, staticRenderFns } from "./message-text.vue?vue&type=template&id=50640654&scoped=true"
import script from "./message-text.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-text.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-text.vue?vue&type=style&index=0&id=50640654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50640654",
  null
  
)

export default component.exports